export default () => {
  const eventTextWrapper = document.querySelector('.event__text-wrapper')
  const eventText = document.querySelector('.event__text')
  const eventDetails = document.querySelector('.event__details-wrapper')
  const readMore = document.querySelector('.event__read-more')
  const readMoreMoreText = document.querySelector('.event__read-more-text--more')
  const readMoreLessText = document.querySelector('.event__read-more-text--less')
  if (!eventTextWrapper || !eventDetails) {
    return
  }
  const eventDetailsMinusOffset = eventDetails.getClientRects()[0].height - 40
  const eventTextWrapperDiff = eventTextWrapper.getClientRects()[0].height - eventText.getClientRects()[0].height
  const readMoreHeight = 50

  if (eventDetails && eventText) {
    if (eventText && eventTextWrapper.getClientRects()[0].height > eventDetailsMinusOffset) {
      eventText.style.maxHeight = `${eventDetailsMinusOffset - eventTextWrapperDiff - readMoreHeight}px`
      readMore.classList.add('event__read-more--show')
    }

    if (readMoreLessText) {
      readMoreLessText.classList.add('hide')
    }

    if (readMore) {
      readMore.addEventListener('click', () => {
        readMore.classList.toggle('event__read-more--expanded')
        if (readMore.classList.contains('event__read-more--expanded')) {
          eventText.style.maxHeight = '2000px'
          readMoreMoreText.classList.add('hide')
          readMoreLessText.classList.remove('hide')
          readMoreLessText.classList.add('show')
        } else {
          eventText.style.maxHeight = `${eventDetailsMinusOffset - eventTextWrapperDiff - readMoreHeight}px`
          readMoreLessText.classList.remove('show')
          readMoreMoreText.classList.remove('hide')
          readMoreLessText.classList.add('hide')
        }
      })
    }
  }
}
